import { render, staticRenderFns } from "./OrderFabricExtraProcessTypeTable.vue?vue&type=template&id=6bebf3d6&"
import script from "./OrderFabricExtraProcessTypeTable.vue?vue&type=script&lang=js&"
export * from "./OrderFabricExtraProcessTypeTable.vue?vue&type=script&lang=js&"
import style0 from "./OrderFabricExtraProcessTypeTable.vue?vue&type=style&index=0&id=6bebf3d6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports